import produce from 'immer'
import { SET_USERS } from './actionTypes'

export const initialState = {
  users: {
    data: [],
    count: null,
  },
}

/* eslint-disable default-case */
const appReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_USERS:
        draft.users = action.data
        break
    }
  })

export default appReducer
